import { ChangeDetectionStrategy, Component, input } from '@angular/core'

@Component({
  selector: 'flx-modal-panel',
  imports: [],
  templateUrl: './modal-panel.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  host: {
    class: 'h-full flex flex-col rounded-lg border border-neutral-100 overflow-hidden',
  },
})
export class ModalPanelComponent {
  headerClass = input<string>('')
}
